// PannelloProva.tsx — nella partita di prova contro il bot: i pulsanti del tester per forzare quello che di solito
// fanno l'avversario o i telefoni (risate riconosciute, accuse, volto, rete, uscita, proposte). Testi del pannello
// di amministrazione (spazio "admin", italiano e inglese): sono strumenti interni.
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { stanza } from "../gioco/stanza.ts";
import { stanzaGruppo } from "../gioco/stanzaGruppo.ts";
import { caricaAdmin } from "../i18n/index.ts";
import { AZIONI_PROVA } from "../../../condiviso/protocollo.ts";
import type { Posto } from "../../../condiviso/gruppo.ts";

export function PannelloProva() {
  const { t } = useTranslation("admin");
  const [aperto, setAperto] = useState(false);
  const [pronto, setPronto] = useState(false);
  useEffect(() => {
    void caricaAdmin().then(() => setPronto(true));
  }, []);
  if (!pronto) return null;
  return (
    <div className="pannello-prova" data-aperto={aperto ? "1" : "0"}>
      <button type="button" className="pulsante pulsante-piccolo pulsante-prova" aria-expanded={aperto} onClick={() => setAperto((a) => !a)}>
        {t("prova.pulsanti")}
      </button>
      {/* v039: vincere con un tocco (per provare la fine della partita e la condivisione) */}
      <button type="button" className="pulsante pulsante-piccolo pulsante-primario pulsante-vinco" data-azione="vinco" onClick={() => stanza.prova("avversario_ride")}>
        {t("prova.vinco")}
      </button>
      {aperto && (
        <div className="pannello-prova-azioni" role="group" aria-label={t("prova.pulsanti")}>
          {AZIONI_PROVA.map((a) => (
            <button
              key={a}
              type="button"
              className="pulsante pulsante-piccolo"
              data-azione={a}
              onClick={() => {
                stanza.prova(a);
                setAperto(false); // si chiude: non copre il video del bot
              }}
            >
              {t(`prova.azione_${a}`)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

/** v039: nella partita a 4 di prova con i bot: far ridere un bot, ridere io, vincere (ridono tutti i bot). */
export function PannelloProvaGruppo({ bot, nomi }: { bot: Posto[]; nomi: Record<Posto, string> }) {
  const { t } = useTranslation("admin");
  const [aperto, setAperto] = useState(false);
  const [pronto, setPronto] = useState(false);
  useEffect(() => {
    void caricaAdmin().then(() => setPronto(true));
  }, []);
  if (!pronto) return null;
  return (
    <div className="pannello-prova" data-aperto={aperto ? "1" : "0"}>
      <button type="button" className="pulsante pulsante-piccolo pulsante-prova" aria-expanded={aperto} onClick={() => setAperto((a) => !a)}>
        {t("prova.pulsanti")}
      </button>
      <button type="button" className="pulsante pulsante-piccolo pulsante-primario pulsante-vinco" data-azione="vinco" onClick={() => stanzaGruppo.provaGruppo("vinco")}>
        {t("prova.vinco")}
      </button>
      {aperto && (
        <div className="pannello-prova-azioni" role="group" aria-label={t("prova.pulsanti")}>
          {bot.map((p) => (
            <button
              key={p}
              type="button"
              className="pulsante pulsante-piccolo"
              data-azione={`bot_ride_${p}`}
              onClick={() => {
                stanzaGruppo.provaGruppo("bot_ride", p);
                setAperto(false);
              }}
            >
              {t("prova.bot_ride", { nome: nomi[p] })}
            </button>
          ))}
          <button
            type="button"
            className="pulsante pulsante-piccolo"
            data-azione="io_rido"
            onClick={() => {
              stanzaGruppo.provaGruppo("io_rido");
              setAperto(false);
            }}
          >
            {t("prova.azione_io_rido")}
          </button>
        </div>
      )}
    </div>
  );
}
